//
import UsagiInfiniteScroll from './class/usagi-infnite-scroll.js';



//
window.pageScroll = {

	timer : null,
	ing : false,
	ready : false,
	local : null,
	body  : null,

	scroll : {
		func : null,
		wrapper : null,
		content : null,
		rect : {
			width : 0,
			height : 0,
		},
		lerp : 0.075,
		y : 0,
		p : 0,
		limit : {
			x : 0,
			y : 0
		},
		trigger : {
			elem : null,
			array : []
		}
	},

	header : {
		el : null,
		y  : null,
		rect : { top:0,left:0,height:0,width:0 }
	},

	footer : {
		el : null,
		rect : { top:0,left:0,height:0,width:0 }
	},

	once(){

		//
		this.header.el = document.querySelector('.c-hd .c-lg a');
		this.header.y  = document.querySelectorAll('.c-hd .c-lg-y');
		this.header.rect = this.header.el.getBoundingClientRect();

		//
		this.scroll.lerp = 0.1;
		if( DETECT.os.win ) this.scroll.lerp  = this.scroll.lerp * 1.5;
		if( DETECT.reduced ) this.scroll.lerp = 0.75;
		if( !DETECT.device.any ) $html.classList.add('is-in-sc');

	},


	type : 'static',
	onInit( elem ){

		//===
		this.local = !elem ? document.querySelector('.c-local') : elem;

		//
		this.scroll.wrapper = this.local.querySelector('.c-local') ? this.local.querySelector('.c-local') : this.local;
		this.scroll.content = this.scroll.wrapper.querySelector('.c-main');

		//===
		this.footer.el = this.local.querySelector('.c-pg-ft');
		if( this.footer.el ) this.footer.rect = this.footer.el.getBoundingClientRect();

		//
		this.onInitSection();

		//
		this.onInitBg();

		//===
		this.onInitScroll();

		//===
		this.onInitAfter();

		//===
		if( !DETECT.device.any ){
			this.onInitLogoStagger();
			this.onInitScrollTrigger();
		}

		//===
		this.onInitScrollTo();

		//===
		this.onResize();

		//===
		this.ready = true;

		//===
		const archiveWrap = this.local.querySelector('.c-ae-wrap');
		if( archiveWrap ){
			this.InfiniteScroll = new UsagiInfiniteScroll({
				local      : this.local,
				wrap       : '.c-ae-wrap',
				body       : '.c-ae-bdy',
				article    : '.c-lp-li',
				paggerWrap : '.c-ae-pag-wrap',
				paggerBody : '.c-ae-pag-bdy',
				paggerNext : '.js-get-nextpage',
				delay : 500,
				onLoadAfter : () => {
					this.onReInit();
				}
			});
		}

	},

	onReInit(){

		//
		styleInview.onReInit();
		if( styleInviewImage ) styleInviewImage.onReInit();
		if( styleInviewVideo ) styleInviewVideo.onReInit();
		if( WEBGL ) if( WEBGL.dom.ready ) WEBGL.dom.onReInit();
		pageTransition.goto.onReInit();

	},

	scrollto : [],
	onInitScrollTo(){

		const $to = this.local.querySelectorAll('.js-scroll-to');

		for (let i = 0; i < $to.length; i++) {
			const el = $to[i];
			this.scrollto.push({
				el : el,
				target : el.getAttribute('href') ? el.getAttribute('href') : 0,
				click : null
			});
		}

		this.scrollto.forEach( (v,i) =>{
			v.click = (e) =>{
				e.preventDefault();
				const to = document.querySelector( v.target ) ? document.querySelector( v.target ) : 0;
				switch( this.type ){
					case 'rich':
						if( this.body ){
							this.body.scrollTo( to, {
								duration : 1,
								lerp : this.scroll.lerp
							});
						}
					break;
					default:
						gsap.to( window, {
							autoKill: true,
							duration: 1,
							scrollTo: to
						});
					break;
				}
			}
			v.el.addEventListener('click',v.click);
		});

	},


	onInitScroll(){

		if( !DETECT.device.any ){

			//
			this.type = 'rich';
			this.body = new Lenis({
				lerp : this.scroll.lerp,
				wrapper  : this.scroll.wrapper,
				content  : this.scroll.content,
			});	

		} else {

			//
			this.type = 'static';
			this.scroll.y = window.scrollY;
			this.scroll.func = (e) =>{
				this.onScroll();
				this.scroll.y = window.scrollY;
				if( WEBGL ){
					if( WEBGL.logo.ready ) WEBGL.logo.onScroll( this.scroll.y );
					if( WEBGL.dom.ready ) WEBGL.dom.onScroll( this.scroll.y );
				}
			}
			window.addEventListener('scroll', this.scroll.func );

		}


	},

	onAutoScroll(){
		const s = getParam('autoScrollSpeed') ? Number( getParam('autoScrollSpeed') ) : 10;
		const rect = this.scroll.content.getBoundingClientRect();
		const to = rect.height - WH;
		switch( this.type ){
			case 'rich':
				if( this.body ){
					this.body.scrollTo( to, {
						duration : s,
						easing: (t) => t,
					});
				}
			break;
			default:
				gsap.to( window, {
					autoKill: true,
					duration: s,
					scrollTo: to
				});
			break;
		}
	},

	onScroll(){

		//===
		if( this.InfiniteScroll ) this.InfiniteScroll.onScroll();

		// //===
		// this.ing = true;
		// clearTimeout( this.timer );
		// this.timer = setTimeout(()=>{ this.ing = false; },100);

	},

	onInitAfter(){
		if( this.body ){
			this.body.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
				this.onScroll();
				this.scroll.y = scroll;
				this.scroll.p = progress;
				this.scroll.limit.x = limit;
				this.scroll.limit.y = limit;
				if( WEBGL ){
					if( WEBGL.logo.ready ) WEBGL.logo.onScroll( this.scroll.y );
					if( WEBGL.dom.ready ) WEBGL.dom.onScroll( this.scroll.y );
				}
			});
		}
	},


	logo : {
		el : null,
		li : null,
		wrap : null,
	},
	onInitLogoStagger(){
		// if( this.logo.li ) this.logo.li.kill(); this.logo.li = null;
		// this.logo.el = this.local.querySelectorAll('.c-lg-sc .c-fnt-y');
		// if( this.logo.el ){
		// 	this.logo.li = gsap.timeline();
		// 	this.logo.li.from( this.logo.el, {
		// 		y: '150%',
		// 		// ease : elastic.out(1, 0.75),
		// 		stagger: 0.05
		// 	});
		// 	this.logo.li.pause();
		// }
	},


	triggers : [],
	onInitScrollTrigger(){

		//===
		this.triggers.forEach( (v,i) =>{
			if( v.tl ) v.tl.kill();
			v.observer.disconnect( v.el );
			v.observer = null;
			v.listerner = null;
			v.tl = null;
		});
		this.triggers = [];

		//===
		this.sticky = this.local.querySelectorAll('.js-sc-tgr');

		//===
		if( this.sticky && !DETECT.reduced ){
			for (let i = 0; i < this.sticky.length; i++) {
				const el = this.sticky[i];
				const trigger = el.querySelector('.js-sc-tgr-target') ? el.querySelector('.js-sc-tgr-target') : el;
				if( trigger ){
					const start = trigger.dataset.start ? trigger.dataset.start : 'top bottom';
					const end = trigger.dataset.end ? trigger.dataset.end : 'bottom top';
					this.triggers.push({
						shown : false,
						visible : false,
						start : start,
						end : end,
						el : el,
						trigger : trigger,
						tl : null,
						listerner : null,
						observer : null
					});
				}
			}
		}

		this.triggers.forEach( (v,i) =>{
			v.listerner = (changes) =>{
				changes.forEach((e, i) => {
					const isIntersecting = e.isIntersecting;
					if ( isIntersecting ) {
						if( !v.shown ){
							v.shown = true;
							v.tl = gsap.to( v.el,{
									ease : 'none',
									scrollTrigger: {
										scroller : this.scroll.wrapper,
										trigger  : v.trigger,
										start    : v.start,
										end      : v.end,
										scrub    : 0.01,
										onUpdate : self => {

											self.trigger.style.setProperty('--p1', self.progress);
											self.trigger.style.setProperty('--p2', 1 - self.progress);

											// if( WEBGL ){
											// 	if( WEBGL.logo.ready ) WEBGL.logo.anim.scroll.tl.progress( self.progress );
											// }

											// if( WEBGL ){
											// 	if( WEBGL.logo.ready ) WEBGL.logo.progress = self.progress;
											// }

											// if( this.logo.li ){
											// 	this.logo.li.progress( self.progress );
											// }
										}
									}
								}
							);
						}
						v.visible = true;
						$html.classList.add('is-lg-sc');
					} else {
						v.visible = false;
						$html.classList.remove('is-lg-sc');
					}
				});
			}
			v.observer = new IntersectionObserver( v.listerner, {threshold: 0} );
			v.observer.observe( v.el );
		});

	},


	section : {
		el : null,
		array : [],
	},
	onInitSection(){
		this.section.array = [];
		this.section.el = this.local.querySelectorAll('.js-sec');
		for (let i = 0; i < this.section.el.length; i++) {
			const el = this.section.el[i];
			this.section.array.push({
				el : el,
				bg : el.dataset.bg
			});
		}
	},


	bg : {
		el : null,
		array : [],
	},
	onInitBg(){
		this.bg.array = [];
		this.bg.el = this.local.querySelectorAll('.js-bg');
		for (let i = 0; i < this.bg.el.length; i++) {
			const el = this.bg.el[i];
			this.bg.array.push({
				el : el,
				bg : el.dataset.bg,
				observer : null,
				listerner : null,
			});
		}
		this.bg.array.forEach( (v,i) =>{
			v.listerner = (changes) => {
				changes.forEach((e, i) => {
					const el = e.target;
					const isIntersecting = e.isIntersecting;
					if ( isIntersecting ) {
						el.dataset.visible = 1;
					} else {
						el.dataset.visible = 0;
					}
				});
			};
			v.observer = new IntersectionObserver( v.listerner, { threshold: 0 } );
			v.observer.observe( v.el );
		});
	},


	onUpdate(){


		//===
		let sec = 0;
		for (let i = 0; i < this.section.array.length; i++) {
			const v = this.section.array[i];
			const rect = v.el.getBoundingClientRect();
			const min = rect.top <= this.header.rect.height/2;
			const max = rect.top + rect.height > this.header.rect.height/2;
			if( min && max ){
				sec++;
			}
		}
		if( sec != 0 ){
			$html.dataset.scCol = 'dark';
		} else {
			$html.dataset.scCol = 'white';
		}


		//===
		let bg = 0;
		for (let i = 0; i < this.bg.array.length; i++) {
			const v = this.bg.array[i];
			if( v.el.dataset.visible === '1' ) bg++;
		}
		if( bg != 0 ){
			$html.dataset.bgCol = 'dark';
		} else {
			$html.dataset.bgCol = 'white';
		}

		//===
		if( this.footer.el && !DETECT.device.any ){
			this.footer.rect = this.footer.el.getBoundingClientRect();
			const y = Math.min( this.footer.rect.top - this.header.rect.height, 0 );
			if( y < 0 ){
				$html.classList.add('is-pg-ft');
			} else {
				$html.classList.remove('is-pg-ft');
			}
			for (let i = 0; i < this.header.y.length; i++) {
				const v = this.header.y[i];
				v.style.transform = 'translateY('+ y * 1.2 +'px)';
			}
		}

	},

	onResize(){
		if( this.scroll.content ) this.scroll.rect = this.scroll.content.getBoundingClientRect();
		if( this.header.el ) this.header.rect = this.header.el.getBoundingClientRect();
	},

	onDestroy(){

		//
		this.ready = false;
		$html.classList.remove('is-pg-ft','is-lg-sc');

		//
		if( this.InfiniteScroll ) this.InfiniteScroll.onDestroy(); this.InfiniteScroll = null;

		//
		if( !DETECT.device.any ){
			if( this.body ){
				this.body.destroy();
				this.body = null;
			}
		} else {
			window.removeEventListener('scroll', this.scroll.func );
		}

		//
		this.scroll.y = 0;
		this.scroll.p = 0;
		this.scroll.limit.x = 0;
		this.scroll.limit.y = 0;

		//
		this.scrollto.forEach( (v,i) =>{
			v.el.removeEventListener('click',v.click);
			v.click = null;
		});

		//
		if( this.footer.el && !DETECT.device.any ){
			for (let i = 0; i < this.header.y.length; i++) {
				const v = this.header.y[i];
				v.style.transform = 'translateY(0px)';
			}
		}
		this.footer.el = null;

		//
		this.bg.array.forEach( (v,i) =>{
			v.observer.disconnect( v.el );
			v.observer = null;
			v.listerner = null;
		});
		this.bg.array = [];

	}

}

pageScroll.once();